<template>
  <div class="o-feed-section-empty">
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionEmpty',

  computed: {
    title () {
      return this.$route.name === 'home' || this.$route.name === 'assets'
        ? this.$t('oFeedSectionEmpty.title.assets')
        : this.$t('oFeedSectionEmpty.title.maps')
    }
  }
}
</script>
